/* ============================================================
   Softpura Theme JS
   ============================================================ */

/* ---------- Cart State ---------- */
let cartData = { items: [], item_count: 0, total_price: 0 };

async function fetchCart() {
  const res = await fetch('/cart.js');
  cartData = await res.json();
  return cartData;
}

async function cartAdd(variantId, quantity, properties) {
  const body = { id: variantId, quantity: quantity || 1 };
  if (properties) body.properties = properties;
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.description || 'Could not add to cart');
  }
  await fetchCart();
  updateCartUI();
  openCartDrawer();
  return cartData;
}

async function cartUpdate(updates) {
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });
  cartData = await res.json();
  updateCartUI();
  return cartData;
}

async function cartChange(id, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, quantity })
  });
  cartData = await res.json();
  updateCartUI();
  return cartData;
}

/* ---------- Cart UI ---------- */
function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
}

function updateCartUI() {
  const count = cartData.item_count || 0;
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
  renderCartDrawer();
}

function renderCartDrawer() {
  const itemsEl = document.getElementById('CartDrawerItems');
  const footerEl = document.getElementById('CartDrawerFooter');
  const subtotalEl = document.getElementById('CartSubtotal');
  if (!itemsEl) return;
  /* panel selector changed from __inner to __panel */

  if (!cartData.items || cartData.items.length === 0) {
    itemsEl.innerHTML = '<p class="sp-cart-drawer__empty">Your cart is empty</p>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  itemsEl.innerHTML = cartData.items.map(item => `
    <div class="sp-cart-item" data-key="${item.key}">
      <div class="sp-cart-item__img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="sp-cart-item__info">
        <p class="sp-cart-item__title">${item.product_title}</p>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="sp-cart-item__variant">${item.variant_title}</p>` : ''}
        <div class="sp-cart-item__row">
          <div class="sp-qty">
            <button class="sp-qty__btn" onclick="changeItemQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span class="sp-qty__val">${item.quantity}</span>
            <button class="sp-qty__btn" onclick="changeItemQty('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
          <span class="sp-cart-item__price">${formatMoney(item.final_line_price)}</span>
        </div>
        <button class="sp-cart-item__remove" onclick="changeItemQty('${item.key}', 0)">Remove</button>
      </div>
    </div>
  `).join('');

  if (footerEl) footerEl.style.display = 'flex';
  if (subtotalEl) subtotalEl.textContent = formatMoney(cartData.total_price);
}

async function changeItemQty(key, qty) {
  await cartChange(key, qty);
}

/* ---------- Cart Drawer ---------- */
function openCartDrawer() {
  if (window.spOpenCart) { window.spOpenCart(); return; }
  const drawer = document.getElementById('CartDrawer');
  if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
  document.body.style.overflow = 'hidden';
  fetchCart().then(() => renderCartDrawer());
}

function closeCartDrawer() {
  if (window.spCloseCart) { window.spCloseCart(); return; }
  const drawer = document.getElementById('CartDrawer');
  if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  if (!document.getElementById('MobileNav')?.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
}

/* ---------- Mobile Nav ---------- */
function openMobileNav() {
  const nav = document.getElementById('MobileNav');
  if (nav) { nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false'); }
  document.body.style.overflow = 'hidden';
}

function closeMobileNav() {
  const nav = document.getElementById('MobileNav');
  if (nav) { nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); }
  if (!document.getElementById('CartDrawer')?.classList.contains('is-open')) {
    document.body.style.overflow = '';
  }
}

/* ---------- Header Scroll ---------- */
(function initHeaderScroll() {
  const header = document.querySelector('.sp-header');
  if (!header) return;
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (y > 80) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    lastY = y;
  }, { passive: true });
})();

/* ---------- Announcement Bar ---------- */
(function initAnnouncement() {
  const bar = document.querySelector('.sp-announcement');
  if (!bar) return;
  const items = bar.querySelectorAll('.sp-announcement__item');
  if (items.length <= 1) return;
  let idx = 0;
  items.forEach((el, i) => el.classList.toggle('is-active', i === 0));
  setInterval(() => {
    items[idx].classList.remove('is-active');
    idx = (idx + 1) % items.length;
    items[idx].classList.add('is-active');
  }, 3500);
})();

/* ---------- Product Page ---------- */
(function initProductPage() {
  const page = document.querySelector('.sp-product');
  if (!page) return;

  /* Gallery thumbnails */
  const mainImg = page.querySelector('.sp-product__main-img img');
  const thumbs = page.querySelectorAll('.sp-product__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      const alt = thumb.dataset.alt;
      if (mainImg) {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        if (alt) mainImg.alt = alt;
      }
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      /* Sync mobile gallery scroll */
      const mobileGallery = page.querySelector('.sp-product__mobile-gallery');
      if (mobileGallery) {
        const idx = thumb.dataset.index;
        const slide = mobileGallery.querySelector(`[data-index="${idx}"]`);
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  });

  /* Mobile gallery scroll dots */
  const mobileGallery = page.querySelector('.sp-product__mobile-gallery');
  const dots = page.querySelectorAll('.sp-product__dot');
  if (mobileGallery && dots.length) {
    mobileGallery.addEventListener('scroll', () => {
      const slides = mobileGallery.querySelectorAll('.sp-product__mobile-slide');
      const scrollLeft = mobileGallery.scrollLeft;
      const width = mobileGallery.offsetWidth;
      const idx = Math.round(scrollLeft / width);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
  }

  /* Subscription toggle */
  const subCards = page.querySelectorAll('.sp-sub-card');
  const priceDisplay = page.querySelector('[data-price-display]');
  const comparePrice = page.querySelector('[data-compare-price]');
  const saveLabel = page.querySelector('[data-save-label]');
  const intervalRow = page.querySelector('.sp-sub-interval');
  const atcBtn = page.querySelector('.sp-atc-btn');
  const atcText = page.querySelector('[data-atc-text]');

  subCards.forEach(card => {
    card.addEventListener('click', () => {
      subCards.forEach(c => c.classList.remove('is-active'));
      card.classList.add('is-active');
      const isSub = card.dataset.type === 'subscribe';
      if (intervalRow) intervalRow.style.display = isSub ? 'flex' : 'none';
      /* Update price based on selected variant + sub type */
      updatePriceDisplay();
    });
  });

  /* Variant / swatch selection */
  const swatches = page.querySelectorAll('.sp-swatch');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('[data-option-index]');
      if (group) group.querySelectorAll('.sp-swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      updateVariant();
    });
  });

  const variantSelects = page.querySelectorAll('.sp-option-select');
  variantSelects.forEach(sel => sel.addEventListener('change', updateVariant));

  function getCurrentVariantId() {
    /* Try data-variant-id set by updateVariant */
    const stored = page.dataset.selectedVariant;
    if (stored) return stored;
    /* Fallback: first available variant */
    const firstInput = page.querySelector('[data-variant-id]');
    return firstInput ? firstInput.dataset.variantId : null;
  }

  function updateVariant() {
    const optionValues = [];
    page.querySelectorAll('[data-option-index]').forEach(group => {
      const active = group.querySelector('.sp-swatch.is-active') || group.querySelector('.sp-option-select');
      if (active) optionValues.push(active.dataset.value || active.value || '');
    });

    /* Match variant */
    const variantData = window.spVariants || [];
    const match = variantData.find(v =>
      optionValues.every((val, i) => v.options[i] === val)
    ) || variantData[0];

    if (match) {
      page.dataset.selectedVariant = match.id;
      updatePriceDisplay(match);
    }
  }

  function updatePriceDisplay(variant) {
    if (!variant) {
      const id = getCurrentVariantId();
      const variantData = window.spVariants || [];
      variant = variantData.find(v => v.id == id) || variantData[0];
    }
    if (!variant) return;

    const isSubSelected = page.querySelector('.sp-sub-card[data-type="subscribe"]')?.classList.contains('is-active');
    const subDiscount = parseFloat(page.dataset.subDiscount || '20') / 100;

    let price = variant.price;
    let compare = variant.compare_at_price;

    if (isSubSelected && subDiscount > 0) {
      compare = price;
      price = Math.round(price * (1 - subDiscount));
    }

    if (priceDisplay) priceDisplay.textContent = formatMoney(price);
    if (comparePrice) {
      if (compare && compare > price) {
        comparePrice.textContent = formatMoney(compare);
        comparePrice.style.display = 'inline';
      } else {
        comparePrice.style.display = 'none';
      }
    }
    if (saveLabel && isSubSelected) {
      saveLabel.textContent = `Save ${Math.round(subDiscount * 100)}%`;
      saveLabel.style.display = 'inline-flex';
    } else if (saveLabel) {
      saveLabel.style.display = 'none';
    }
    if (atcText) {
      atcText.textContent = `Add to cart — ${formatMoney(price)}`;
    }
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-soldout');
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-soldout');
        atcBtn.querySelector('[data-atc-text]') && (atcBtn.querySelector('[data-atc-text]').textContent = 'Sold out');
      }
    }
  }

  /* ATC button */
  if (atcBtn) {
    atcBtn.addEventListener('click', async () => {
      const variantId = getCurrentVariantId();
      if (!variantId) return;
      const isSubSelected = page.querySelector('.sp-sub-card[data-type="subscribe"]')?.classList.contains('is-active');
      const intervalEl = page.querySelector('.sp-interval-select');
      const properties = {};
      if (isSubSelected && intervalEl) {
        properties['Delivery interval'] = intervalEl.value;
        properties['_subscription'] = 'true';
      }
      atcBtn.classList.add('is-loading');
      try {
        await cartAdd(variantId, 1, isSubSelected ? properties : null);
      } catch (e) {
        alert(e.message);
      } finally {
        atcBtn.classList.remove('is-loading');
      }
    });
  }

  /* Sticky ATC bar scroll */
  const stickyBar = document.querySelector('.sp-sticky-atc');
  const atcArea = page.querySelector('.sp-product__right');
  if (stickyBar && atcArea) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(atcArea);

    const stickyBtn = stickyBar.querySelector('.sp-sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        atcBtn?.click();
      });
    }
  }

  /* Accordion */
  page.querySelectorAll('.sp-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.sp-accordion__item');
      const body = item?.querySelector('.sp-accordion__body');
      const isOpen = item?.classList.contains('is-open');
      /* Close all */
      page.querySelectorAll('.sp-accordion__item.is-open').forEach(el => {
        el.classList.remove('is-open');
        const b = el.querySelector('.sp-accordion__body');
        if (b) b.style.maxHeight = '0';
      });
      if (!isOpen && body) {
        item.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* Init price display */
  updateVariant();
})();

/* ---------- Global Accordion (non-product pages) ---------- */
document.querySelectorAll('.sp-accordion__trigger').forEach(trigger => {
  if (trigger.closest('.sp-product')) return; /* handled above */
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.sp-accordion__item');
    const body = item?.querySelector('.sp-accordion__body');
    const isOpen = item?.classList.contains('is-open');
    item?.closest('.sp-accordion')?.querySelectorAll('.sp-accordion__item.is-open').forEach(el => {
      el.classList.remove('is-open');
      const b = el.querySelector('.sp-accordion__body');
      if (b) b.style.maxHeight = '0';
    });
    if (!isOpen && body) {
      item.classList.add('is-open');
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  });
});

/* ---------- Quick Add Buttons ---------- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  const variantId = btn.dataset.quickAdd;
  if (!variantId) return;
  btn.classList.add('is-loading');
  try {
    await cartAdd(variantId, 1);
  } catch (err) {
    alert(err.message);
  } finally {
    btn.classList.remove('is-loading');
  }
});

/* ---------- Cart Page Qty ---------- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-cart-qty]');
  if (!btn) return;
  const key = btn.dataset.cartQty;
  const action = btn.dataset.action;
  const item = cartData.items.find(i => i.key === key);
  if (!item) return;
  const newQty = action === 'inc' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
  await cartChange(key, newQty);
  /* Refresh page if on cart page */
  if (window.location.pathname === '/cart') location.reload();
});

/* ---------- Header Nav Dropdown ---------- */
document.querySelectorAll('.sp-nav__item--has-dropdown').forEach(item => {
  let timer;
  item.addEventListener('mouseenter', () => {
    clearTimeout(timer);
    item.classList.add('is-open');
  });
  item.addEventListener('mouseleave', () => {
    timer = setTimeout(() => item.classList.remove('is-open'), 150);
  });
});

/* ---------- Search Toggle ---------- */
const searchToggle = document.querySelector('[data-search-toggle]');
const searchPanel = document.querySelector('.sp-header__search-panel');
if (searchToggle && searchPanel) {
  searchToggle.addEventListener('click', () => {
    const isOpen = searchPanel.classList.toggle('is-open');
    if (isOpen) searchPanel.querySelector('input')?.focus();
  });
}

/* ---------- Init ---------- */
document.addEventListener('DOMContentLoaded', () => {
  fetchCart().then(updateCartUI);
});
